import React from 'react';
import { Range } from 'rc-slider';
import PropTypes from 'prop-types';
import styles from '../../../../searchV2.scss';

const defaultRangeDisplay = (min, max) => {
    if (min === max) {
        return max.toString();
    }
    return `${min} to ${max}`;
};

const RangeFilter = (props) => {
    const {
        onChange,
        rangeKeyMin,
        rangeKeyMax,
        defaultValueArr,
        min,
        max,
        title,
        customRangeDisplay,
        isHalfSteps,
    } = props;

    const minVal = min || defaultValueArr[0];
    const maxVal = max || defaultValueArr[1];
    const rangeDisplay = customRangeDisplay ? customRangeDisplay(minVal, maxVal) : defaultRangeDisplay(minVal, maxVal);

    return (
        <React.Fragment>
            <p className={styles.rangeTitle}>{title}</p>
            <div className={styles.rangeContainer}>
                <p className={styles.rangeText}>Range</p>
                <p className={styles.rangeText}>{rangeDisplay}</p>
            </div>

            {/* Always use standard range wrapper without pickleball-specific classes */}
            <div className="range-wrapper">
                <Range
                    min={rangeKeyMin}
                    max={rangeKeyMax}
                    value={[min, max]}
                    onChange={onChange}
                    step={isHalfSteps ? 0.5 : 1}
                />
            </div>
        </React.Fragment>
    );
};

RangeFilter.propTypes = {
    onChange: PropTypes.func,
    rangeKeyMin: PropTypes.number.isRequired,
    rangeKeyMax: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    customRangeDisplay: PropTypes.func,
    isHalfSteps: PropTypes.bool,
};

RangeFilter.defaultProps = {
    onChange: () => {},
    customRangeDisplay: null,
    isHalfSteps: false,
};

export default RangeFilter;
